// to add a new LTI tool name, add an entry to LTI_NAME_MAP below
import ACLStore from "lib/aclStore";
import { ENABLE_LTI_LAUNCH_FAIL_SAFE_BUTTON } from "Constants/permissionConstants";
import _ from "lodash";

export const LTI_PLACEMENT = {
  ASSIGNMENT: "ASSIGNMENT",
  COURSE: "COURSE",
  HOMEPAGE: "HOMEPAGE",
  // TEMP: routes to "COURSE" until backend ships the COURSE_HOMEPAGE enum value (EN3B-921 Task 0).
  // Revert to "COURSE_HOMEPAGE" once backend lands.
  COURSE_HOMEPAGE: "COURSE",
};

export const LTI_THUMB_URLS = {
  MS365:
    "https://images.seeklogo.com/logo-png/50/2/microsoft-365-copilot-logo-png_seeklogo-501781.png",
};

export const LTI_SERVICE_DETAILS = {
  EDPUZZLE: {
    label: "Edpuzzle",
    messageType: "CONTENT_ITEM_SELECTION",
    messageTypeV2: "CONTENT_ITEM_SELECTION_REQUEST",
    allowStudentReportView: true,
    disableTeacherReportView: false,
    useInAppBrowser: false,
    featureFlag: "Common:EnableEdpuzzleLTITool",
    thumbUrl:
      "https://play-lh.googleusercontent.com/MACIkVCNnNsPS-E-VAjIguH9IDUM_1xtvBu016EAzcshxYXJKM4B6a8r36EYgqASOh8",
    showLaunchUrlField: false,
    url: {
      launchUrl: "https://edpuzzle.com/lti/assignments/create",
      stopLinkCreation: true,
    },
    versions: ["1.1"],
    placement: LTI_PLACEMENT.ASSIGNMENT,
    allowAllStudentSubmissionView: true, // Allow teacher to view all student submissions reports
  },
  CLICKVIEW: {
    label: "ClickView",
    messageType: "BASIC_LTI_LAUNCH",
    messageTypeV2: "BASIC_LTI_LAUNCH_REQUEST",
    allowStudentReportView: false,
    disableTeacherReportView: true,
    useInAppBrowser: true,
    dashBoardRedirectionUrl: "https://www.clickview.net/shared-by-me",
    featureFlag: "Common:EnableClickviewLTITool",
    thumbUrl: "https://online.clickview.com.au/Assets/images/icons/cv-logo.png",
    showLaunchUrlField: false,
    url: {
      launchUrl: "https://lti.clickviewapp.com/launch",
      stopLinkCreation: true,
    },
    versions: ["1.1", "1.3"],
    placement: LTI_PLACEMENT.ASSIGNMENT,
    allowAllStudentSubmissionView: false,
  },
  H5P: {
    label: "H5P",
    messageType: "CONTENT_ITEM_SELECTION",
    messageTypeV2: "CONTENT_ITEM_SELECTION_REQUEST",
    allowStudentReportView: false,
    disableTeacherReportView: false,
    useInAppBrowser: false,
    featureFlag: "Common:EnableH5pLTITool",
    thumbUrl:
      "https://upload.wikimedia.org/wikipedia/commons/9/9b/H5P_Logo.png",
    showLaunchUrlField: true,
    url: {
      launchUrl: "",
      stopLinkCreation: true,
    },
    versions: ["1.1", "1.3"],
    placement: LTI_PLACEMENT.ASSIGNMENT,
    allowAllStudentSubmissionView: true,
  },
  EDUCAPLAY: {
    label: "Educaplay",
    messageType: "BASIC_LTI_LAUNCH",
    messageTypeV2: "BASIC_LTI_LAUNCH_REQUEST",
    allowStudentReportView: false,
    disableTeacherReportView: false,
    useInAppBrowser: false,
    featureFlag: "Common:EnableEducaplayLTITool",
    thumbUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4gpnnFO9UCUONdgDN3ge6PUDGewgjDiJbqGwwb203BAmJPHsyz0NGVhoxEMZ9yoU8iLQ&usqp=CAU",
    showLaunchUrlField: false,
    url: {
      launchUrl: "https://www.educaplay.com/lti/",
      stopLinkCreation: false,
    },
    versions: ["1.1"],
    placement: LTI_PLACEMENT.ASSIGNMENT,
    allowAllStudentSubmissionView: true,
  },
  TURNITIN: {
    label: "Turnitin Feedback Studio",
    messageType: "CONTENT_ITEM_SELECTION",
    messageTypeV2: "CONTENT_ITEM_SELECTION_REQUEST",
    allowStudentReportView: false,
    disableTeacherReportView: false,
    useInAppBrowser: false,
    featureFlag: "Common:EnableTurnitinLTITool",
    thumbUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQmXx7AVy0UtaVJIeDd2dJZUot0lSpKY_DyAA&s",
    url: {
      launchUrl: "",
    },
    default_ags_claim: "lineitems",
    versions: ["1.3"],
    placement: LTI_PLACEMENT.ASSIGNMENT,
    allowAllStudentSubmissionView: true,
  },
  QUIZIZZ: {
    label: "Wayground",
    messageType: "CONTENT_ITEM_SELECTION",
    messageTypeV2: "CONTENT_ITEM_SELECTION_REQUEST",
    allowStudentReportView: false,
    disableTeacherReportView: false,
    useInAppBrowser: false,
    featureFlag: "Common:EnableQuizizzLTITool",
    thumbUrl:
      "https://media.licdn.com/dms/image/v2/D560BAQGjG0U_iVPsHQ/company-logo_200_200/company-logo_200_200/0/1724654940155/quizizz_logo?e=2147483647&v=beta&t=buxotZyHTmB_hro6BhNTugoewetc_QyRekMTgb5c6Ng",
    url: {
      launchUrl: "",
    },
    versions: ["1.3"],
    default_nrps_claim: {
      userFields: ["name", "email"],
    },
    custom_params: { lti_integration_id: "lti_integration_id" },
    custom_paramsV2: [
      { key: "lti_integration_id", localeKey: "lti_integration_id" },
    ],
    placement: LTI_PLACEMENT.ASSIGNMENT,
    allowAllStudentSubmissionView: true,
  },
  MCGRAWHILL: {
    label: "McGrawHill",
    messageType: "BASIC_LTI_LAUNCH",
    messageTypeV2: "BASIC_LTI_LAUNCH_REQUEST",
    allowStudentReportView: false,
    disableTeacherReportView: true,
    useInAppBrowser: false,
    featureFlag: "Common:EnableMcGrawHillLTITool",
    showLaunchUrlField: true,
    url: {
      launchUrl: "https://aairs.tegrity.com/Service/RedirectCMSLink.aspx",
    },
    thumbUrl:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/McGraw-Hill_Education_wordmark.svg/1200px-McGraw-Hill_Education_wordmark.svg.png",
    versions: ["1.1"],
    placement: LTI_PLACEMENT.HOMEPAGE,
    allowAllStudentSubmissionView: false,
  },
  ONENOTE: {
    label: "OneNote",
    messageType: "BASIC_LTI_LAUNCH",
    messageTypeV2: "BASIC_LTI_LAUNCH_REQUEST",
    allowStudentReportView: false,
    disableTeacherReportView: true,
    useInAppBrowser: true,
    featureFlag: "Common:EnableOnenoteLTITool",
    thumbUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQZ0y4nIDZLv8hGMxa_OwfWRBnIzOhvm1jSww&s",
    showLaunchUrlField: false,
    url: {
      launchUrl: "https://www.onenote.com/lti",
    },
    versions: ["1.1"],
    placement: LTI_PLACEMENT.COURSE,
    allowAllStudentSubmissionView: false,
  },
  SPONTE: {
    messageType: "BASIC_LTI_LAUNCH",
    messageTypeV2: "BASIC_LTI_LAUNCH_REQUEST",
    label: "Mais Serviços",
    versions: ["1.3"],
    featureFlag: "Common:EnableMBSponteLTIIntegration",
    placement: LTI_PLACEMENT.HOMEPAGE,
    allowAllStudentSubmissionView: false,
  },
  KOGNITY: {
    messageType: "BASIC_LTI_LAUNCH",
    label: "Kognity",
    featureFlag: "Common:EnableKognityLTITool",
    placement: LTI_PLACEMENT.ASSIGNMENT,
    versions: ["1.1"],
  },
  MS365: {
    label: "Microsoft Education",
    messageType: "CONTENT_ITEM_SELECTION",
    messageTypeV2: "CONTENT_ITEM_SELECTION_REQUEST",
    allowStudentReportView: false,
    disableTeacherReportView: false,
    useInAppBrowser: false,
    featureFlag: "Common:EnableMS365LTITool",
    thumbUrl: LTI_THUMB_URLS.MS365,
    showLaunchUrlField: true,
    url: {
      launchUrl: "",
      stopLinkCreation: true,
    },
    versions: ["1.3"],
    placement: [LTI_PLACEMENT.ASSIGNMENT, LTI_PLACEMENT.COURSE],
    allowAllStudentSubmissionView: true,
  },
  ATOMI: {
    label: "Atomi",
    messageType: "CONTENT_ITEM_SELECTION",
    messageTypeV2: "CONTENT_ITEM_SELECTION_REQUEST",
    allowStudentReportView: true,
    disableTeacherReportView: false,
    useInAppBrowser: true,
    featureFlag: "Common:EnableAtomiLTITool",
    thumbUrl: "https://learn.getatomi.com/favicon.ico",
    showLaunchUrlField: false,
    url: {
      launchUrl: "https://api.getatomi.com/nucleus/api/lti/launch",
      stopLinkCreation: true,
    },
    versions: ["1.1"],
    placement: LTI_PLACEMENT.ASSIGNMENT,
    allowAllStudentSubmissionView: true,
  },
  CUSTOM: {
    label: "Custom",
    messageType: "BASIC_LTI_LAUNCH",
    versions: ["1.0", "1.1", "1.3"],
  },
};

export const LTI_NAME_MAP = {
  edpuzzle: "Edpuzzle",
  clickview: "ClickView",
  h5p: "H5P",
  educaplay: "Educaplay",
  turnitin: "Turnitin Feedback Studio",
  quizizz: "Wayground",
  mcgrawhill: "McGrawHill",
  onenote: "OneNote",
  sponte: "Mais Serviços",
  kognity: "Kognity",
  ms365: "Microsoft Education",
  atomi: "Atomi",
};

export const KOGNITY_CREDS_FIELDS = [
  {
    field: "clientId",
    path: "clientId",
    localeKey: "client_id",
  },
  {
    field: "clientSecret",
    path: "clientSecret",
    localeKey: "client_secret",
  },
  {
    field: "apiToken",
    path: "apiToken",
    localeKey: "access_token",
  },
  {
    field: "region",
    path: "region",
    localeKey: "region",
  },
];

export const LTI_PLATFORM_CREDS_FIELDS = [
  {
    field: "issuerUrl",
    path: "toddleCreds.issuerUrl",
    localeKey: "issuer_url",
  },
  {
    field: "toddleClientId",
    path: "toddleCreds.toddleClientId",
    localeKey: "client_identifier",
  },
  {
    field: "toddleloginUrl",
    path: "toddleCreds.toddleloginUrl",
    localeKey: "login_url",
  },
  {
    field: "toddleJwkUrl",
    path: "toddleCreds.toddleJwkUrl",
    localeKey: "keyset_url",
  },
  {
    field: "toddleTokenUrl",
    path: "toddleCreds.toddleTokenUrl",
    localeKey: "token_url",
  },
  {
    field: "deploymentId",
    path: "metadata.deployment_id",
    localeKey: "deployment_identifier",
  },
];

export const LTI_LABELS_MAP = {
  issuerUrl: "issuer_url",
  toddleloginUrl: "login_url",
  toddleJwkUrl: "keyset_url",
  toddleTokenUrl: "token_url",
};

export const getIsLtiLaunchFailSafeEnabled = () => {
  return ACLStore.can(ENABLE_LTI_LAUNCH_FAIL_SAFE_BUTTON);
};

export const isLTIMobileViewFromUrl = () =>
  new URLSearchParams(location.search).get("isLTIMobileView") === "true";

export const DIRECT_LTI_LAUNCH_SERVICES = ["ONENOTE"];

export const getLTIName = serviceName => LTI_NAME_MAP[_.toLower(serviceName)];
